export default __webpack_public_path__ + "static/media/greeting12.c08f72c6.png";